/* ===========================================================
   LUMÈRA — Landing page behaviour
   No hardcoded variant IDs: the variant matrix is rendered by
   Liquid into a JSON script tag and matched at runtime.
   =========================================================== */
(function () {
  'use strict';
  if (window.__lumeraLpLoaded) return;
  window.__lumeraLpLoaded = true;

  var money = function (cents, format) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    // Format placeholders used by Shopify money formats
    return (format || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, (cents / 100).toFixed(2));
  };

  /* ------------------------------------------------------------------ */
  /* Accordion                                                           */
  /* ------------------------------------------------------------------ */
  function initAccordions(root) {
    root.querySelectorAll('[data-lum-acc]').forEach(function (acc) {
      if (acc.dataset.lumAccReady) return;
      acc.dataset.lumAccReady = '1';
      acc.querySelectorAll('.lum-acc__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = btn.nextElementSibling;
          var open = btn.getAttribute('aria-expanded') === 'true';
          if (acc.dataset.lumAcc === 'single' && !open) {
            acc.querySelectorAll('.lum-acc__btn[aria-expanded="true"]').forEach(function (o) {
              o.setAttribute('aria-expanded', 'false');
              if (o.nextElementSibling) o.nextElementSibling.dataset.open = 'false';
            });
          }
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (panel) panel.dataset.open = open ? 'false' : 'true';
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Gallery                                                             */
  /* ------------------------------------------------------------------ */
  function initGallery(root) {
    root.querySelectorAll('[data-lp-gallery]').forEach(function (gal) {
      if (gal.dataset.ready) return;
      gal.dataset.ready = '1';

      var track = gal.querySelector('[data-lp-gal-track]');
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-lp-gal-thumb]'));
      var dots = Array.prototype.slice.call(gal.querySelectorAll('[data-lp-gal-dot]'));
      var slides = Array.prototype.slice.call(gal.querySelectorAll('.lp-gal__slide'));
      if (!track || !slides.length) return;

      var current = 0;

      /* O poster fica parado se o play() sair antes de haver dados.        */
      /* Tenta outra vez quando o video ja da para reproduzir.              */
      function tryPlay(vid) {
        var pl = vid.play();
        if (!pl || !pl.catch) return;
        pl.catch(function () {
          if (vid.dataset.lumRetry) return;
          vid.dataset.lumRetry = '1';
          vid.addEventListener('canplay', function again() {
            vid.removeEventListener('canplay', again);
            var p2 = vid.play();
            if (p2 && p2.catch) p2.catch(function () {});
          });
        });
      }

      function mark(i) {
        current = i;
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        slides.forEach(function (s, n) {
          var vid = s.querySelector('video');
          if (!vid) return;
          if (n === i) {
            vid.muted = true;
            if (vid.preload === 'none') vid.preload = 'auto';
            tryPlay(vid);
          } else {
            vid.pause();
          }
        });
      }

      function goTo(i, smooth) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
        mark(i);
      }

      window.addEventListener('lp:relayout', function () { goTo(current, false); });

      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

      gal.querySelectorAll('[data-lp-gal-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          goTo(current + (btn.dataset.dir === 'next' ? 1 : -1));
        });
      });

      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bestDist = Infinity;
          slides.forEach(function (s, i) {
            var c = s.offsetLeft - track.offsetLeft + s.clientWidth / 2;
            var d = Math.abs(c - mid);
            if (d < bestDist) { bestDist = d; best = i; }
          });
          mark(best);
        });
      }, { passive: true });

      gal.addEventListener('lp:show-media', function (e) {
        var id = String(e.detail && e.detail.mediaId || '');
        if (!id) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].dataset.mediaId === id) { goTo(i); break; }
        }
      });

      mark(0);
    });
  }

  function mediaIdFromGallerySlides(color) {
    var needle = String(color || '').toLowerCase();
    if (!needle) return '';
    var slides = document.querySelectorAll('.lp-gal__slide');
    var pack = '';
    var worn = '';
    var any = '';
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      var src = (img && (img.getAttribute('src') || '')).toLowerCase();
      if (src.indexOf(needle) === -1) continue;
      var id = slides[i].dataset.mediaId || '';
      if (!id) continue;
      if (!any) any = id;
      if (src.indexOf('vorder') !== -1 || src.indexOf('rueckseite') !== -1) {
        if (!pack) pack = id;
      } else if (src.indexOf('getragen') !== -1) {
        if (!worn) worn = id;
      }
    }
    return pack || worn || any;
  }

  function mediaIdForColor(color) {
    color = String(color || '');
    var box = document.querySelector('[data-lp-buybox]');
    var dataEl = box && box.querySelector('[data-lp-product-json]');
    if (dataEl) {
      try {
        var variants = (JSON.parse(dataEl.textContent).variants) || [];
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v.options && v.options[0] === color && v.featured_media_id) {
            return String(v.featured_media_id);
          }
        }
      } catch (err) { /* ignore */ }
    }
    return mediaIdFromGallerySlides(color);
  }

  function showColorMedia(color) {
    var id = mediaIdForColor(color);
    if (!id) return;
    document.querySelectorAll('[data-lp-gallery]').forEach(function (gal) {
      gal.dispatchEvent(new CustomEvent('lp:show-media', { detail: { mediaId: id } }));
    });
  }

  document.addEventListener('lp:show-color', function (e) {
    var color = e.detail && e.detail.color;
    if (color) showColorMedia(color);
  });

  /* ------------------------------------------------------------------ */
  /* Buy box                                                             */
  /* ------------------------------------------------------------------ */
  function initBuyBox(root) {
    root.querySelectorAll('[data-lp-buybox]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';

      var dataEl = box.querySelector('[data-lp-product-json]');
      if (!dataEl) return;

      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var variants = data.variants || [];
      var moneyFormat = data.moneyFormat;
      var section = box.closest('[data-lp-section]') || document;
      var gallery = section.querySelector('[data-lp-gallery]') ||
                    document.querySelector('[data-lp-gallery]');

      var form = box.querySelector('form');
      var variantInput = box.querySelector('[data-lp-variant-input]');
      var qtyInput = box.querySelector('[data-lp-qty-input]');
      var submitBtn = box.querySelector('[data-lp-submit]');
      var priceNow = box.querySelector('[data-lp-price-now]');
      var priceWas = box.querySelector('[data-lp-price-was]');
      var priceSave = box.querySelector('[data-lp-price-save]');
      var unitNote = box.querySelector('[data-lp-unit-note]');
      var stockNote = box.querySelector('[data-lp-stock]');
      var galBadge = (box.closest('[data-lp-section]') || document).querySelector('[data-lp-gal-badge]');
      var offerInputs = Array.prototype.slice.call(box.querySelectorAll('[data-lp-offer]'));
      var optionInputs = Array.prototype.slice.call(box.querySelectorAll('[data-lp-option]'));

      function selectedOptions() {
        var out = [];
        optionInputs.forEach(function (input) {
          if (input.checked) out[parseInt(input.dataset.optionIndex, 10)] = input.value;
        });
        return out;
      }

      function findVariant(opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var k = 0; k < opts.length; k++) {
            if (opts[k] != null && v.options[k] !== opts[k]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      /* Grey out option values that produce no available variant */
      function refreshAvailability(opts) {
        optionInputs.forEach(function (input) {
          var idx = parseInt(input.dataset.optionIndex, 10);
          var probe = opts.slice();
          probe[idx] = input.value;
          var match = null;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i], ok = true;
            for (var k = 0; k < probe.length; k++) {
              if (probe[k] != null && v.options[k] !== probe[k]) { ok = false; break; }
            }
            if (ok) { match = v; break; }
          }
          var wrap = input.closest('.lp-opt');
          if (wrap) wrap.classList.toggle('lp-opt--unavailable', !match || !match.available);
        });
      }

      function currentQty() {
        var checked = offerInputs.filter(function (i) { return i.checked; })[0];
        return checked ? parseInt(checked.dataset.qty, 10) || 1 : 1;
      }

      function updateOfferPrices(variant) {
        if (!variant) return;
        offerInputs.forEach(function (input) {
          var qty = parseInt(input.dataset.qty, 10) || 1;
          var extra = parseFloat(input.dataset.discount || '0') || 0;
          var wrap = input.parentNode;
          var total = Math.round(variant.price * qty * (1 - extra / 100));
          var was = variant.compare_at_price && variant.compare_at_price > variant.price
            ? variant.compare_at_price * qty
            : (extra > 0 ? variant.price * qty : 0);
          var nowEl = wrap.querySelector('[data-lp-offer-now]');
          var wasEl = wrap.querySelector('[data-lp-offer-was]');
          if (nowEl) nowEl.textContent = money(total, moneyFormat);
          if (wasEl) {
            wasEl.textContent = was ? money(was, moneyFormat) : '';
            wasEl.hidden = !was;
          }
        });
      }

      function update() {
        var opts = selectedOptions();
        refreshAvailability(opts);
        var variant = findVariant(opts);
        var qty = currentQty();

        if (variantInput) variantInput.value = variant ? variant.id : '';
        var priceLocked = box.hasAttribute('data-lp-lock-price');
        if (!priceLocked && qtyInput) qtyInput.value = qty;

        if (!priceLocked) updateOfferPrices(variant);

        if (variant) {
          var total = variant.price * qty;
          var checked = offerInputs.filter(function (i) { return i.checked; })[0];
          var extra = checked ? (parseFloat(checked.dataset.discount || '0') || 0) : 0;
          total = Math.round(total * (1 - extra / 100));
          var wasTotal = variant.compare_at_price && variant.compare_at_price > variant.price
            ? variant.compare_at_price * qty : 0;

          if (!priceLocked) {
          if (priceNow) priceNow.textContent = money(total, moneyFormat);
          if (priceWas) {
            priceWas.textContent = wasTotal ? money(wasTotal, moneyFormat) : '';
            priceWas.hidden = !wasTotal;
          }
          if (priceSave) {
            if (wasTotal > total) {
              var pct = Math.round((1 - total / wasTotal) * 100);
              priceSave.textContent = priceSave.dataset.template
                ? priceSave.dataset.template.replace('%s', pct)
                : '-' + pct + '%';
              priceSave.hidden = false;
            } else {
              priceSave.hidden = true;
            }
          }
          if (unitNote && qty > 1) {
            unitNote.textContent = (unitNote.dataset.template || '{price} pro Stück')
              .replace('{price}', money(Math.round(total / qty), moneyFormat));
            unitNote.hidden = false;
          } else if (unitNote) {
            unitNote.hidden = true;
          }
          }

          /* Knappheit: so aus dem echten Bestand (stock === null => nicht verfolgt => nichts anzeigen) */
          if (stockNote) {
            var thr = parseInt(stockNote.dataset.threshold || '0', 10) || 0;
            var st = typeof variant.stock === 'number' ? variant.stock : null;
            if (st !== null && st > 0 && st <= thr) {
              var stEl = stockNote.querySelector('[data-lp-stock-text]');
              if (stEl) stEl.textContent = (stockNote.dataset.template || 'Nur noch %s Stück').replace('%s', st);
              stockNote.hidden = false;
            } else {
              stockNote.hidden = true;
            }
          }
          if (galBadge) {
            var bthr = stockNote ? (parseInt(stockNote.dataset.threshold || '0', 10) || 0) : 0;
            var bst = typeof variant.stock === 'number' ? variant.stock : null;
            if (bst !== null && bst > 0 && bst <= bthr) {
              galBadge.textContent = '\uD83D\uDD25 ' + (galBadge.dataset.lowTemplate || 'Nur noch %s Stück').replace('%s', bst);
              galBadge.classList.add('lp-gal__badge--low');
              galBadge.hidden = false;
            } else {
              galBadge.textContent = galBadge.dataset.default || '';
              galBadge.classList.remove('lp-gal__badge--low');
              galBadge.hidden = !galBadge.dataset.default;
            }
          }

          if (submitBtn) {
            var label = variant.available
              ? (submitBtn.dataset.labelAvailable || 'In den Warenkorb')
              : (submitBtn.dataset.labelSoldOut || 'Ausverkauft');
            submitBtn.textContent = label;
            submitBtn.disabled = !variant.available;
          }

          /* Featured media of the variant is applied only after the shopper
             actively picks a color (trusted click / lp:show-color). Load stays
             on the first gallery slide (GIF). */

          /* Reflect selection in URL for sharing / back button */
          if (window.history && window.history.replaceState && data.updateUrl) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }
        } else if (submitBtn) {
          submitBtn.textContent = submitBtn.dataset.labelUnavailable || 'Nicht verfügbar';
          submitBtn.disabled = true;
        }

        /* Selected-value echo in the step headers */
        box.querySelectorAll('[data-lp-step-value]').forEach(function (el) {
          var idx = parseInt(el.dataset.lpStepValue, 10);
          el.textContent = opts[idx] || '';
        });

        /* Kurzer Hinweis unter den Größen-Buttons */
        box.querySelectorAll('[data-lp-opt-hint]').forEach(function (el) {
          var idx = parseInt(el.dataset.lpOptHint, 10);
          var picked = optionInputs.filter(function (i) {
            return i.checked && parseInt(i.dataset.optionIndex, 10) === idx;
          })[0];
          el.textContent = (picked && picked.dataset.hint) ? picked.dataset.hint : '';
        });

        /* Sticky bar mirror — so escreve a seleccao se a barra nao tiver copy fixa */
        document.querySelectorAll('[data-lp-sticky-meta]').forEach(function (el) {
          if (el.dataset.fixed === 'true') return;
          var parts = opts.filter(Boolean);
          if (qty > 1) parts.push(qty + '×');
          el.textContent = parts.join(' · ');
        });
        if (!priceLocked) {
        document.querySelectorAll('[data-lp-sticky-price]').forEach(function (el) {
          if (priceNow) el.textContent = priceNow.textContent;
        });
        }
      }

      optionInputs.forEach(function (i) {
        i.addEventListener('change', function (e) {
          update();
          if (e.isTrusted && parseInt(i.dataset.optionIndex, 10) === 0) {
            showColorMedia(i.value);
          }
        });
      });
      offerInputs.forEach(function (i) { i.addEventListener('change', update); });

      if (form) {
        form.addEventListener('cart:error', function (e) {
          var err = box.querySelector('[data-lp-error]');
          if (err) { err.textContent = (e.detail && e.detail.error) || ''; err.hidden = false; }
        });
      }

      update();
      box.dataset.lpReady = 'true';
    });
  }

  /* ------------------------------------------------------------------ */
  /* Comprar sem sair do sitio (barra fixa e CTAs da LP)                 */
  /* ------------------------------------------------------------------ */
  function bindBuy(btn) {
    if (!btn || btn.dataset.buyReady) return;
    btn.dataset.buyReady = '1';
    btn.addEventListener('click', function (e) {
      var buybox = document.querySelector('[data-lp-buybox]');
      var submit = buybox && buybox.querySelector('[data-lp-submit]');
      e.preventDefault();

      /* Sem botao de compra, ou esgotado: mostrar a buy box em vez de falhar em silencio. */
      if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') {
        if (buybox) buybox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (btn.dataset.busy === '1') return;
      btn.dataset.busy = '1';
      setTimeout(function () { btn.dataset.busy = ''; }, 1200);

      /* NAO usar submit.click(): o .click() poe o foco no botao e o browser faz
         scroll ate ele, o que atira a pagina de volta para o topo.
         requestSubmit() dispara o mesmo evento 'submit' que o <form is="product-form">
         ja escuta, sem mexer no foco nem no scroll. */
      var form = submit.form || (buybox && buybox.querySelector('form'));
      if (form && typeof form.requestSubmit === 'function') {
        form.requestSubmit(submit);
        return;
      }

      /* Browsers antigos sem requestSubmit: clicar e repor o scroll logo a seguir. */
      var y = window.pageYOffset;
      var keep = function () {
        if (Math.abs(window.pageYOffset - y) > 2) window.scrollTo(0, y);
      };
      submit.click();
      keep();
      if (window.requestAnimationFrame) window.requestAnimationFrame(keep);
      setTimeout(keep, 80);
    });
  }

  /* Qualquer CTA da LP marcado para comprar directamente */
  function initBuyLinks(root) {
    root.querySelectorAll('[data-lp-buy-now]').forEach(bindBuy);
  }

  /* ------------------------------------------------------------------ */
  /* Sticky add-to-cart                                                  */
  /* ------------------------------------------------------------------ */
  function initSticky(root) {
    var sticky = root.querySelector('[data-lp-sticky]');
    if (!sticky || sticky.dataset.ready) return;
    sticky.dataset.ready = '1';

    /* A barra fixa passa a aparecer logo a seguir a foto principal, e nao so
       quando o botao de compra sai do ecra (o buy box e comprido). */
    var anchor = document.querySelector('[data-lp-gallery]')
              || document.querySelector('[data-lp-gallery-slot]')
              || document.querySelector('[data-lp-cta-anchor]');
    if (!anchor) return;

    var show = function (v) { sticky.dataset.visible = v ? 'true' : 'false'; };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { rootMargin: '0px 0px -100% 0px' }).observe(anchor);
    }

    sticky.querySelectorAll('[data-lp-sticky-buy]').forEach(bindBuy);

    /* Qualquer outro CTA dentro da barra fixa continua a levar a buy box. */
    sticky.querySelectorAll('[data-lp-scroll-to-buy]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.querySelector('[data-lp-buybox]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* Any CTA anywhere that should jump to the buy box */
  function initScrollLinks(root) {
    root.querySelectorAll('[data-lp-scroll-to-buy]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function (e) {
        var target = document.querySelector('[data-lp-buybox]');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* Size-guide dialog opener */
  function initDialogs(root) {
    root.querySelectorAll('[data-lp-open]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(btn.dataset.lpOpen);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }


  /* ------------------------------------------------------------------ */
  /* Reviews: "show more" + photo-strip jump                             */
  /* ------------------------------------------------------------------ */
  function initReviews(root) {
    root.querySelectorAll('[data-lp-reviews]').forEach(function (list) {
      if (list.dataset.ready) return;
      list.dataset.ready = '1';

      var cards = Array.prototype.slice.call(list.querySelectorAll('[data-lp-review]'));
      var step = parseInt(list.dataset.step, 10) || 4;
      var section = list.closest('.lum') || document;
      var btn = section.querySelector('[data-lp-reviews-more]');
      var colsWrap = null;
      var cols = [];

      function colCount() {
        var v = parseInt(getComputedStyle(list).getPropertyValue('--rv-cols'), 10);
        return (v >= 1 && v <= 6) ? v : 1;
      }

      function shortestCol() {
        var best = cols[0];
        for (var i = 1; i < cols.length; i++) {
          if (cols[i].offsetHeight < best.offsetHeight) best = cols[i];
        }
        return best;
      }

      function build() {
        var n = colCount();
        if (colsWrap && cols.length === n) return;
        if (colsWrap) colsWrap.remove();
        colsWrap = document.createElement('div');
        colsWrap.className = 'lp-rv__cols';
        cols = [];
        for (var i = 0; i < n; i++) {
          var c = document.createElement('div');
          c.className = 'lp-rv__col';
          cols.push(c);
          colsWrap.appendChild(c);
        }
        list.appendChild(colsWrap);
        list.classList.add('lp-rv__list--built');
        cards.forEach(function (card) {
          if (!card.hasAttribute('hidden')) shortestCol().appendChild(card);
        });
      }

      function visibleCount() {
        return cards.filter(function (c) { return !c.hasAttribute('hidden'); }).length;
      }

      /* Neue Karten werden UNTEN angehängt – die alten bleiben, wo sie sind. */
      function reveal(n) {
        var shown = 0;
        for (var i = 0; i < cards.length && shown < n; i++) {
          if (cards[i].hasAttribute('hidden')) {
            cards[i].removeAttribute('hidden');
            shortestCol().appendChild(cards[i]);
            shown++;
          }
        }
        syncButton();
        return shown;
      }

      function syncButton() {
        if (!btn) return;
        if (visibleCount() >= cards.length) {
          btn.disabled = true;
          btn.textContent = btn.dataset.labelAll || btn.textContent;
        } else {
          btn.disabled = false;
          btn.textContent = btn.dataset.label || btn.textContent;
        }
      }

      if (btn) {
        btn.addEventListener('click', function () {
          reveal(step);
        });
        syncButton();
      }

      build();

      var rsz;
      window.addEventListener('resize', function () {
        clearTimeout(rsz);
        rsz = setTimeout(build, 150);
      });
      window.addEventListener('lp:relayout', function () { build(); });
    });
  }


  /* ------------------------------------------------------------------ */
  /* Rail layout: sticky gallery left, narrow LP column right (desktop)  */
  /* ------------------------------------------------------------------ */
  var RAIL_MQ = '(min-width: 1080px)';

  function teardownRail() {
    var rail = document.querySelector('.lp-rail');
    if (!rail) return;
    var host = rail.parentNode;
    var gal = rail.querySelector('[data-lp-gallery]');
    var stage = document.querySelector('[data-lp-gallery-slot]');
    if (gal && stage) stage.appendChild(gal);
    var right = rail.querySelector('.lp-rail__right');
    while (right && right.firstChild) host.insertBefore(right.firstChild, rail);
    rail.remove();
  }

  function buildRail() {
    if (document.querySelector('.lp-rail')) return;
    var hero = document.querySelector('[data-lp-hero-section]');
    if (!hero) return;

    var count = parseInt(hero.dataset.railSections, 10);
    if (isNaN(count) || count < 0) count = 9;
    if (count === 0) return;

    var gal = hero.querySelector('[data-lp-gallery]');
    if (!gal) return;

    /* Shopify wraps each section in #shopify-section-… — take that wrapper if present */
    var heroTop = hero.closest('[id^="shopify-section-"]') || hero;
    var host = heroTop.parentNode;

    var members = [heroTop];
    var node = heroTop.nextElementSibling;
    while (node && members.length <= count) {
      if (node.querySelector && node.querySelector('.lum')) members.push(node);
      node = node.nextElementSibling;
    }

    var rail = document.createElement('div');
    rail.className = 'lp-rail';
    var left = document.createElement('div');
    left.className = 'lp-rail__left';
    var right = document.createElement('div');
    right.className = 'lp-rail__right';
    rail.appendChild(left);
    rail.appendChild(right);
    host.insertBefore(rail, heroTop);

    left.appendChild(gal);
    members.forEach(function (m) { right.appendChild(m); });
  }

  var railWant = null;
  var railTimer = 0;

  function applyRail() {
    var want = window.matchMedia(RAIL_MQ).matches;
    if (want === railWant) return;
    railWant = want;
    if (want) buildRail();
    else teardownRail();
    window.dispatchEvent(new CustomEvent('lp:relayout'));
  }

  function syncRail() {
    clearTimeout(railTimer);
    railTimer = setTimeout(applyRail, 180);
  }

  var railBound = false;
  function initRail() {
    applyRail();
    if (railBound) return;
    railBound = true;
    var mq = window.matchMedia(RAIL_MQ);
    if (mq.addEventListener) mq.addEventListener('change', syncRail);
    else if (mq.addListener) mq.addListener(syncRail);
  }

  /* ------------------------------------------------------------------ */
  /* Videos que so tocam quando estao mesmo a ser vistos                 */
  /*                                                                     */
  /* Com autoplay o browser descarrega e descodifica os tres videos da   */
  /* pagina ao mesmo tempo — e isso que fazia o scroll arrastar.         */
  /* Aqui o ficheiro so e pedido quando entra no ecra, e para quando sai.*/
  /* ------------------------------------------------------------------ */
  function initAutoVideos(root) {
    var vids = root.querySelectorAll('video[data-lum-autovid]');
    if (!vids.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { if (!reduce) { v.muted = true; v.play().catch(function () {}); } });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (reduce) return;
          v.muted = true;
          var pl = v.play();
          if (pl && pl.catch) pl.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.35 });

    vids.forEach(function (v) {
      if (v.dataset.lumVidReady) return;
      v.dataset.lumVidReady = '1';
      io.observe(v);
    });
  }

  /* "In den Warenkorb": se a MESMA variante (mesmo tamanho) ja estiver no carrinho,
     nao adiciona outra vez — so abre o carrinho. Tamanho diferente = adiciona. */
  function initNoDuplicateAdd(root) {
    var forms = root.querySelectorAll('form[is="product-form"]');
    forms.forEach(function (form) {
      if (form.dataset.lumNodup) return;
      form.dataset.lumNodup = '1';
      form.addEventListener('submit', function (e) {
        if (form.dataset.lumPass === '1') { delete form.dataset.lumPass; return; }
        var idEl = form.querySelector('input[name="id"]');
        var id = idEl ? String(idEl.value) : '';
        if (!id) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var inCart = (cart.items || []).some(function (it) { return String(it.variant_id) === id; });
            if (inCart) {
              var d = document.getElementById('cart-drawer');
              if (d && typeof d.show === 'function') { d.show(); } else { window.location.href = rootUrl + 'cart'; }
              return;
            }
            form.dataset.lumPass = '1';
            if (typeof form.requestSubmit === 'function') { form.requestSubmit(); } else { form.submit(); }
          })
          .catch(function () { form.dataset.lumPass = '1'; form.requestSubmit(); });
      }, true);
    });
  }

  function boot(root) {
    root = root || document;
    initNoDuplicateAdd(root);
    initAccordions(root);
    initReviews(root);
    initGallery(root);
    initBuyBox(root);
    initSticky(root);
    initBuyLinks(root);
    initScrollLinks(root);
    initDialogs(root);
    initRail();
    initAutoVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* Shopify theme editor re-render hooks */
  document.addEventListener('shopify:section:load', function (e) {
    teardownRail();
    boot(e.target);
    syncRail();
  });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
